/****************************************************
 * Module Name:  NotificationNew.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Badge, Box } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Utility from "../../utility/utility";
import NotificationProxy from "../../utility/proxy/notification/notificationProxy";
import Constants from "../../utility/constants";
import { BsFillBellFill } from "react-icons/bs";
import NotificationModalNew from "./notificationModalNew";

const NotificationNew = memo(() => {

    // Access Cookies
    const cookies = useCookies()[0];
    const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
    const [unreadNotification, setUnreadNotification] = useState();
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [intervalRef, setIntervalRef] = useState(null);

    useEffect(() => {
        if (verifyCookies()) {
            getUnreadCount(); // Call API only if cookies are valid
            setIntervalRef(setInterval(() => getUnreadCount(), 30000));
        }
    }, []);

    const verifyCookies = () => {
        if (!cookies.loggedInUser || !cookies.userToken || !cookies.loggedInUser.expires ||
            new Date(cookies.loggedInUser.expires) < new Date()) {
            Utility.ReloadSite();
            return false;
        }
        return true;
    }

    const getUnreadCount = () => {
        NotificationProxy.GetUnreadNotificationForUserCount(Constants.loggedInUser.id, false, (response) => {
            let totalUnread = 0;
            response.forEach((iUnreadCnt) => {
                totalUnread = totalUnread + iUnreadCnt.count;
            });

            setUnreadNotificationCount(totalUnread);
            setUnreadNotification(response);
        });
    }

    const handleNotificationModalOpen = () => {
        if (intervalRef)
            clearInterval(intervalRef);
        setShowNotificationModal(true);
        setIntervalRef(null);
    }

    const handleNotificationModalClose = () => {
        getUnreadCount();
        setShowNotificationModal(false);
        setIntervalRef(setInterval(() => getUnreadCount(), 10000));
    }

    return (
        <Box>
            {showNotificationModal ? (
                <NotificationModalNew
                    handleClose={() => handleNotificationModalClose()}
                    unReadNotification={unreadNotification}
                />
            ) : null}

            <Box
                sx={{ cursor: "pointer" }}
                onClick={(e) => handleNotificationModalOpen()}
            >
                <Badge color="error" badgeContent={unreadNotificationCount} max={99}>
                    <BsFillBellFill size={22} color={unreadNotificationCount > 0 ? "inherit" : "lightgray"} />
                </Badge>
            </Box>
        </Box>
    )
});

export default NotificationNew;